import { useEffect, useRef } from "react";
import { motion, useMotionTemplate, useMotionValue, useSpring, useTransform } from "framer-motion";

export const Emblem3D = ({ className = "", trackWindow = false, testid = "emblem-3d" }) => {
  const ref = useRef(null);
  const mx = useMotionValue(0.5);
  const my = useMotionValue(0.5);
  const rx = useSpring(useTransform(my, [0, 1], [20, -20]), { stiffness: 110, damping: 15 });
  const ry = useSpring(useTransform(mx, [0, 1], [-26, 26]), { stiffness: 110, damping: 15 });
  const sx = useTransform(mx, [0, 1], [15, 85]);
  const sy = useTransform(my, [0, 1], [15, 85]);
  const shine = useMotionTemplate`radial-gradient(circle at ${sx}% ${sy}%, rgba(255,255,255,0.75), rgba(255,255,255,0) 42%)`;

  const set = (x, y, r) => {
    mx.set(Math.min(1, Math.max(0, (x - r.left) / r.width)));
    my.set(Math.min(1, Math.max(0, (y - r.top) / r.height)));
  };

  useEffect(() => {
    if (!trackWindow) return undefined;
    const on = (e) => set(e.clientX, e.clientY, { left: 0, top: 0, width: window.innerWidth, height: window.innerHeight });
    window.addEventListener("pointermove", on);
    return () => window.removeEventListener("pointermove", on);
  }, [trackWindow]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div
      ref={ref}
      data-testid={testid}
      className={`[perspective:900px] ${className}`}
      onPointerMove={trackWindow ? undefined : (e) => set(e.clientX, e.clientY, ref.current.getBoundingClientRect())}
      onPointerLeave={() => { mx.set(0.5); my.set(0.5); }}
    >
      <motion.div animate={{ y: [0, -12, 0] }} transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}>
        <motion.div
          style={{ rotateX: rx, rotateY: ry, transformStyle: "preserve-3d" }}
          className="relative aspect-square w-full rounded-full shadow-[0_50px_90px_-30px_rgba(0,0,0,0.75)]"
        >
          <img src="/img/emblem-v2.png" alt="MARKHOR silver metal emblem" draggable={false} className="h-full w-full select-none rounded-full" />
          <motion.div style={{ background: shine }} className="pointer-events-none absolute inset-0 rounded-full mix-blend-soft-light" />
        </motion.div>
      </motion.div>
    </div>
  );
};
